import { render, staticRenderFns } from "./PlayToEarn.vue?vue&type=template&id=41c728ee&scoped=true&"
var script = {}
import style0 from "./PlayToEarn.vue?vue&type=style&index=0&id=41c728ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c728ee",
  null
  
)

export default component.exports